import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

export const get_my_list = createAsyncThunk(
    'myList/get_my_list',
    async(userId, { rejectWithValue, fulfillWithValue }) => {
        try {
            const {data} = await api.get(`/home/product/get-my-list/${userId}`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)
// End Method

export const add_to_my_list = createAsyncThunk(
    'myList/add_to_my_list',
    async(info, { rejectWithValue, fulfillWithValue }) => {
        try {
            const {data} = await api.post('/home/product/add-to-my-list', info)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)
// End Method

export const update_my_list_quantity = createAsyncThunk(
    'myList/update_my_list_quantity',
    async({ myListId, quantity }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const {data} = await api.put(`/home/product/my-list-quantity/${myListId}`, { quantity })
            return fulfillWithValue({ myListId, quantity: data.quantity, message: data.message })
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)
// End Method

export const remove_from_my_list = createAsyncThunk(
    'myList/remove_from_my_list',
    async(myListId, { rejectWithValue, fulfillWithValue }) => {
        try {
            const {data} = await api.delete(`/home/product/remove-my-list/${myListId}`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)
// End Method

export const bulk_add_my_list_to_card = createAsyncThunk(
    'myList/bulk_add_my_list_to_card',
    async({ userId, myListIds }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const {data} = await api.post('/home/product/my-list-bulk-add-to-card', { userId, myListIds })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)
// End Method

export const myListReducer = createSlice({
    name: 'myList',
    initialState: {
        myList: [],
        myListCount: 0,
        errorMessage: '',
        successMessage: '',
        loading: false
    },
    reducers: {
        messageClear: (state, _) => {
            state.errorMessage = ""
            state.successMessage = ""
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(get_my_list.pending, (state) => {
            state.loading = true
        })
        .addCase(get_my_list.fulfilled, (state, { payload }) => {
            state.loading = false
            state.myList = payload.myList
            state.myListCount = payload.myListCount
        })
        .addCase(get_my_list.rejected, (state) => {
            state.loading = false
        })

        .addCase(add_to_my_list.rejected, (state, { payload }) => {
            state.errorMessage = payload?.error || 'Failed to add to My List'
        })
        .addCase(add_to_my_list.fulfilled, (state, { payload }) => {
            state.successMessage = payload.message
        })

        .addCase(update_my_list_quantity.fulfilled, (state, { payload }) => {
            const item = state.myList.find(i => i._id === payload.myListId)
            if (item) item.quantity = payload.quantity
        })
        .addCase(update_my_list_quantity.rejected, (state, { payload }) => {
            state.errorMessage = payload?.error || 'Failed to update quantity'
        })

        .addCase(remove_from_my_list.fulfilled, (state, { payload }) => {
            state.successMessage = payload.message
            state.myList = state.myList.filter(i => i._id !== payload.myListId)
            state.myListCount = state.myList.length
        })

        .addCase(bulk_add_my_list_to_card.fulfilled, (state, { payload }) => {
            state.successMessage = payload.message
        })
        .addCase(bulk_add_my_list_to_card.rejected, (state, { payload }) => {
            state.errorMessage = payload?.error || 'Failed to add selected products to cart'
        })
    }
})

export const { messageClear } = myListReducer.actions
export default myListReducer.reducer
